import type { BackendRouteDefinition } from '../types';

export interface MarkFlatFeeEarnedRequest {
  matterId: string;
  attemptId: string;
  amountCents: number;
  noteContent: string;
  newStatus: 'earnedButNotClosed' | 'closed';
  finixEnvironment: 'live' | 'sandbox';
}

export interface MarkFlatFeeEarnedResponse {
  feeEarningId: string;
  retainerTransferId: string;
  status: 'created' | 'alreadyCreated';
}

export const markFlatFeeEarnedRoute = {
  body: (request: MarkFlatFeeEarnedRequest) => ({
    attemptId: request.attemptId,
    amountCents: request.amountCents,
    noteContent: request.noteContent,
    newStatus: request.newStatus,
    finixEnvironment: request.finixEnvironment,
  }),
  method: 'POST',
  params: (request: MarkFlatFeeEarnedRequest) => ({
    matterId: request.matterId,
  }),
  path: '/firms/matters/:matterId/earned-flat-fees',
  transport: 'api',
} as const satisfies BackendRouteDefinition;
